
import React, { useState, useEffect } from "react";
import { 
  FaQuoteLeft, 
  FaQuoteRight, 
  FaChevronLeft, 
  FaChevronRight,
  FaStar,
  FaLinkedin,
  FaEdit,
  FaSave,
  FaTimes,
  FaPlus,
  FaTrash,
  FaImage,
  FaMapMarkerAlt,
  FaBuilding,
  FaGraduationCap,
  FaBriefcase
} from "react-icons/fa";

const EnhancedTestimonialsEditor = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(-1);
  
  const [testimonials, setTestimonials] = useState([
    {
      id: 1,
      name: "Dideesh Babu",
      role: "Full Stack Developer | React.js | Blockchain",
      content: "Congratulations Maneesh! Your dedication to blockchain technology and innovative approach to problem-solving is truly inspiring. Your work in the industry showcases exceptional technical expertise and innovation. Keep pushing the boundaries of what's possible in blockchain development!",
      image: "/images/Screenshot from 2025-08-28 00-42-46.png",
      rating: 5,
      company: "Government Engineering College Idukki",
      location: "Kannur, Kerala, India",
      specializations: ["Ethereum", "Smart Contracts", "Hyperledger Fabric", "React.js"],
      education: "B.Tech in EEE",
      experience: "3+ years",
      linkedinUrl: "#"
    },
    {
      id: 2,
      name: "Neethu M",
      role: "Innovation Engineer – Blockchain | Hyperledger, Ethereum, DAML",
      content: "Congratulations! 🎉 Your expertise in blockchain technology and innovative solutions continues to amaze me. Your dedication to advancing decentralized technologies and smart contract development is truly exceptional. Looking forward to seeing more groundbreaking work from you!",
      image: "/images/Screenshot from 2025-08-28 00-44-31.png",
      rating: 5,
      company: "Indian Institute of Information Tech & Mgt-Kerala",
      location: "Kerala, India",
      specializations: ["RWA Tokenization", "Smart Contracts", "Decentralized Applications", "MERN Stack"],
      education: "M.Tech CSE, PG Diploma in Blockchain",
      experience: "2+ years",
      linkedinUrl: "#"
    },
    {
      id: 3,
      name: "Maneesha Raj",
      role: "Software Engineer | MERN Stack Developer",
      content: "👏👏👏 Amazing work Maneesh! Your full-stack development skills combined with blockchain expertise make you a true tech innovator. Your ability to deliver complex solutions and bridge traditional development with cutting-edge blockchain technology is outstanding. Congratulations on your continued success!",
      image: "/images/Screenshot from 2025-08-28 00-44-06.png",
      rating: 5,
      company: "LambdaZen LLC",
      location: "Alappuzha, Kerala, India",
      specializations: ["MERN Stack", "Blockchain", "Full Stack Development", "REST APIs"],
      education: "PG Diploma in Blockchain",
      experience: "1+ years",
      linkedinUrl: "#"
    },
    {
      id: 4,
      name: "Kiran SS",
      role: "Electrical Engineer | Substation Operations | Data Center",
      content: "Congrats Maneesh! Your ability to bridge traditional engineering with cutting-edge blockchain technology is impressive. Your technical expertise in both electrical systems and modern blockchain solutions demonstrates remarkable versatility. Great work on integrating innovative technologies with practical applications!",
      image: "/images/Screenshot from 2025-08-28 00-43-42.png",
      rating: 5,
      company: "SCOPE T&M",
      location: "Thiruvananthapuram, Kerala, India",
      specializations: ["SCADA Operations", "Data Analysis", "Power BI", "Substation Maintenance"],
      education: "B.Tech Electrical Engineering",
      experience: "8+ years",
      linkedinUrl: "#"
    },
    {
      id: 5,
      name: "Arun P S",
      role: "Project Manager | 8 Years Agile & Traditional Projects",
      content: "Congratulations! 🎉 Working with professionals like Maneesh has been fantastic. His technical skills, innovative approach to blockchain solutions, and project delivery capabilities are top-notch. Your ability to manage complex technical projects while staying ahead of emerging technologies is truly commendable. Well deserved success!",
      image: "/images/Screenshot from 2025-08-28 00-43-16.png",
      rating: 5,
      company: "UST Global",
      location: "Thiruvananthapuram, Kerala, India",
      specializations: ["Digital Transformation", "Agile Methodologies", "PMP®", "CSM®"],
      education: "PMP® Certified, CSM® Certified",
      experience: "8+ years",
      linkedinUrl: "#"
    },
    {
      id: 6,
      name: "Gishnu Devadathan",
      role: " Blockchain Developer | Researcher",
      content: "Congratulations Maneesh Madhusudhanan! Your research contributions and technical expertise in blockchain development are remarkable. Your innovative approach to solving complex problems and dedication to advancing blockchain technology is truly inspiring. Excited to see your future projects!",
      image: "/images/Screenshot from 2025-08-28 00-50-31.png",
      rating: 5,
      company: "Freelance developer",
      location: "Kerala, India",
      specializations: ["Blockchain Research", "Smart Contracts", "Hyperledger Fabric", "Ethereum"],
      education: "PG Diploma in Blockchain",
      experience: "1+ years",
      linkedinUrl: "#"
    }
  ]);

  const [editForm, setEditForm] = useState({
    name: "",
    role: "",
    content: "",
    image: "",
    rating: 5,
    company: "",
    location: "",
    specializations: [],
    education: "",
    experience: "",
    linkedinUrl: "#"
  });

  // Auto-rotation effect
  useEffect(() => {
    if (!isAutoPlaying || isEditing) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    
    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length, isEditing]);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  const startEditing = (index) => {
    setEditingIndex(index);
    setEditForm({ ...testimonials[index] });
    setIsEditing(true);
    setIsAutoPlaying(false);
  };

  const cancelEditing = () => {
    setIsEditing(false);
    setEditingIndex(-1);
    setEditForm({ 
      name: "", 
      role: "", 
      content: "", 
      image: "", 
      rating: 5, 
      company: "",
      location: "",
      specializations: [],
      education: "",
      experience: "",
      linkedinUrl: "#"
    });
  };

  const saveTestimonial = () => {
    if (editingIndex === -1) {
      // Add new testimonial
      const newTestimonial = {
        ...editForm,
        id: Math.max(...testimonials.map(t => t.id)) + 1
      };
      setTestimonials([...testimonials, newTestimonial]);
    } else {
      // Update existing testimonial
      const updatedTestimonials = testimonials.map((t, index) => 
        index === editingIndex ? { ...editForm, id: t.id } : t
      );
      setTestimonials(updatedTestimonials);
    }
    cancelEditing();
  };

  const deleteTestimonial = (index) => {
    const updatedTestimonials = testimonials.filter((_, i) => i !== index);
    setTestimonials(updatedTestimonials);
    if (currentIndex >= updatedTestimonials.length) {
      setCurrentIndex(Math.max(0, updatedTestimonials.length - 1));
    }
  };

  const addNewTestimonial = () => {
    setEditingIndex(-1);
    setEditForm({ 
      name: "", 
      role: "", 
      content: "", 
      image: "", 
      rating: 5, 
      company: "",
      location: "",
      specializations: [],
      education: "",
      experience: "",
      linkedinUrl: "#"
    });
    setIsEditing(true);
    setIsAutoPlaying(false);
  };

  const getRandomImage = () => {
    const imageUrls = [
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      "https://images.unsplash.com/photo-1494790108755-2616b612b3fd?w=150&h=150&fit=crop&crop=face",
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
      "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=150&h=150&fit=crop&crop=face",
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face",
      "https://images.unsplash.com/photo-1557862921-37829c790f19?w=150&h=150&fit=crop&crop=face"
    ];
    return imageUrls[Math.floor(Math.random() * imageUrls.length)];
  };

  const handleSpecializationChange = (value) => {
    const specializations = value.split(',').map(s => s.trim()).filter(s => s.length > 0);
    setEditForm({ ...editForm, specializations });
  };

  if (testimonials.length === 0) {
    return (
      <section className="relative min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-4xl font-bold text-white mb-4">No Testimonials Yet</h2>
          <button
            onClick={addNewTestimonial}
            className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-3 rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 transition-all"
          >
            <FaPlus className="inline mr-2" />
            Add First Professional
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="relative min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 overflow-hidden">
      {/* Editor Modal */}
      {isEditing && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto border border-white/20">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-white">
                {editingIndex === -1 ? "Add New Professional" : "Edit Professional Profile"}
              </h3>
              <button
                onClick={cancelEditing}
                className="text-white hover:text-red-400 transition-colors"
              >
                <FaTimes size={24} />
              </button>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-white text-sm font-medium mb-2">Full Name</label>
                  <input
                    type="text"
                    value={editForm.name}
                    onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-300"
                    placeholder="Enter full name"
                  />
                </div>

                <div>
                  <label className="block text-white text-sm font-medium mb-2">Professional Role</label>
                  <input
                    type="text"
                    value={editForm.role}
                    onChange={(e) => setEditForm({ ...editForm, role: e.target.value })}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-300"
                    placeholder="Enter role/title"
                  />
                </div>

                <div>
                  <label className="block text-white text-sm font-medium mb-2">Company/Organization</label>
                  <input
                    type="text"
                    value={editForm.company}
                    onChange={(e) => setEditForm({ ...editForm, company: e.target.value })}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-300"
                    placeholder="Enter company name"
                  />
                </div>

                <div>
                  <label className="block text-white text-sm font-medium mb-2">Location</label>
                  <input
                    type="text"
                    value={editForm.location}
                    onChange={(e) => setEditForm({ ...editForm, location: e.target.value })}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-300"
                    placeholder="e.g., Thiruvananthapuram, Kerala, India"
                  />
                </div>

                <div>
                  <label className="block text-white text-sm font-medium mb-2">Education</label>
                  <input
                    type="text"
                    value={editForm.education}
                    onChange={(e) => setEditForm({ ...editForm, education: e.target.value })}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-300"
                    placeholder="e.g., M.Tech CSE, B.Tech EEE"
                  />
                </div>

                <div>
                  <label className="block text-white text-sm font-medium mb-2">Experience</label>
                  <input
                    type="text"
                    value={editForm.experience}
                    onChange={(e) => setEditForm({ ...editForm, experience: e.target.value })}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-300"
                    placeholder="e.g., 5+ years"
                  />
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-white text-sm font-medium mb-2">Testimonial Content</label>
                  <textarea
                    value={editForm.content}
                    onChange={(e) => setEditForm({ ...editForm, content: e.target.value })}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-300 h-32 resize-none"
                    placeholder="Enter testimonial content"
                  />
                </div>

                <div>
                  <label className="block text-white text-sm font-medium mb-2">Specializations</label>
                  <input
                    type="text"
                    value={editForm.specializations.join(', ')}
                    onChange={(e) => handleSpecializationChange(e.target.value)}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-300"
                    placeholder="e.g., Blockchain, React.js, Smart Contracts (comma separated)"
                  />
                </div>

                <div>
                  <label className="block text-white text-sm font-medium mb-2">Profile Image URL</label>
                  <div className="flex gap-2">
                    <input
                      type="url"
                      value={editForm.image}
                      onChange={(e) => setEditForm({ ...editForm, image: e.target.value })}
                      className="flex-1 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-300"
                      placeholder="Enter image URL"
                    />
                    <button
                      onClick={() => setEditForm({ ...editForm, image: getRandomImage() })}
                      className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors"
                      title="Get Random Image"
                    >
                      <FaImage />
                    </button>
                  </div>
                  {editForm.image && (
                    <div className="mt-2">
                      <img
                        src={editForm.image}
                        alt="Preview"
                        className="w-16 h-16 rounded-full object-cover border-2 border-white/20"
                      />
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-white text-sm font-medium mb-2">LinkedIn URL</label>
                  <input
                    type="url"
                    value={editForm.linkedinUrl}
                    onChange={(e) => setEditForm({ ...editForm, linkedinUrl: e.target.value })}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-300"
                    placeholder="https://linkedin.com/in/username"
                  />
                </div>

                <div>
                  <label className="block text-white text-sm font-medium mb-2">Rating</label>
                  <div className="flex items-center space-x-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <button
                        key={star}
                        onClick={() => setEditForm({ ...editForm, rating: star })}
                        className={`text-2xl transition-colors ${
                          star <= editForm.rating ? 'text-yellow-400' : 'text-gray-400'
                        }`}
                      >
                        <FaStar />
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end space-x-4 mt-8">
              <button
                onClick={cancelEditing}
                className="px-6 py-2 text-white border border-white/20 rounded-lg hover:bg-white/10 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={saveTestimonial}
                className="px-6 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all"
              >
                <FaSave className="inline mr-2" />
                Save Professional
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Control Panel */}
      <div className="absolute top-4 right-4 z-20">
        <div className="bg-white/10 backdrop-blur-lg rounded-xl p-4 border border-white/20">
          <div className="flex space-x-2">
            <button
              onClick={addNewTestimonial}
              className="bg-green-500 hover:bg-green-600 text-white p-2 rounded-lg transition-colors"
              title="Add New Professional"
            >
              <FaPlus />
            </button>
            <button
              onClick={() => startEditing(currentIndex)}
              className="bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-lg transition-colors"
              title="Edit Current Professional"
            >
              <FaEdit />
            </button>
            <button
              onClick={() => deleteTestimonial(currentIndex)}
              className="bg-red-500 hover:bg-red-600 text-white p-2 rounded-lg transition-colors"
              title="Delete Current Professional"
            >
              <FaTrash />
            </button>
          </div>
        </div>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-64 h-64 bg-gradient-to-r from-blue-400/20 to-purple-400/20 rounded-full blur-xl animate-pulse" />
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-gradient-to-r from-pink-400/20 to-blue-400/20 rounded-full blur-xl animate-pulse" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-gradient-to-r from-green-400/10 to-blue-400/10 rounded-full blur-xl animate-bounce" />
      </div>

      <div className="relative z-10 container mx-auto px-6 py-20">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <div className="bg-gradient-to-r from-blue-400 to-purple-400 p-4 rounded-full">
              <FaQuoteLeft className="text-white text-2xl" />
            </div>
          </div>
          
          <h2 className="text-5xl md:text-7xl font-bold text-white mb-6">
            Professional 
            <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              {" "}Network
            </span>
          </h2>
          
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Recognition and testimonials from industry professionals, colleagues, and collaborators
          </p>
        </div>

        {/* Main Testimonial Display */}
        <div className="relative max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-3 gap-8 items-start">
            {/* Professional Profile Card */}
            <div className="lg:col-span-1">
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20 sticky top-8">
                <div className="text-center mb-6">
                  <div className="w-24 h-24 mx-auto rounded-full overflow-hidden border-4 border-blue-400 mb-4">
                    <img
                      src={testimonials[currentIndex].image}
                      alt={testimonials[currentIndex].name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {testimonials[currentIndex].name}
                  </h3>
                  <p className="text-gray-300 text-sm mb-4">
                    {testimonials[currentIndex].role}
                  </p>
                  
                  <div className="flex items-center justify-center mb-4">
                    {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                      <FaStar key={i} className="text-yellow-400 text-lg mr-1" />
                    ))}
                  </div>
                </div>

                <div className="space-y-3 text-sm">
                  <div className="flex items-center text-gray-300">
                    <FaBuilding className="text-blue-400 mr-3 flex-shrink-0" />
                    <span className="break-words">{testimonials[currentIndex].company}</span>
                  </div>
                  
                  <div className="flex items-center text-gray-300">
                    <FaMapMarkerAlt className="text-blue-400 mr-3 flex-shrink-0" />
                    <span className="break-words">{testimonials[currentIndex].location}</span>
                  </div>
                  
                  <div className="flex items-center text-gray-300">
                    <FaGraduationCap className="text-blue-400 mr-3 flex-shrink-0" />
                    <span className="break-words">{testimonials[currentIndex].education}</span>
                  </div>
                  
                  <div className="flex items-center text-gray-300">
                    <FaBriefcase className="text-blue-400 mr-3 flex-shrink-0" />
                    <span>{testimonials[currentIndex].experience}</span>
                  </div>
                </div>

                <div className="mt-6">
                  <h4 className="text-white font-semibold mb-3">Specializations</h4>
                  <div className="flex flex-wrap gap-2">
                    {testimonials[currentIndex].specializations.map((spec, index) => (
                      <span
                        key={index}
                        className="bg-gradient-to-r from-blue-400/20 to-purple-400/20 text-blue-300 px-3 py-1 rounded-full text-xs border border-blue-400/30"
                      >
                        {spec}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="mt-6 text-center">
                  <a
                    href={testimonials[currentIndex].linkedinUrl}
                    className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin className="mr-2" />
                    Connect
                  </a>
                </div>
              </div>
            </div>

            {/* Testimonial Content */}
            <div className="lg:col-span-2">
              <div className="relative">
                <div className="absolute -top-6 -left-6 text-6xl text-blue-400/30">
                  <FaQuoteLeft />
                </div>
                
                <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 min-h-[300px] flex flex-col justify-center">
                  <p className="text-lg md:text-xl text-white leading-relaxed italic">
                    {testimonials[currentIndex].content}
                  </p>
                </div>
                
                <div className="absolute -bottom-6 -right-6 text-6xl text-purple-400/30">
                  <FaQuoteRight />
                </div>
              </div>

              {/* Navigation Controls */}
              <div className="mt-8">
                <div className="flex items-center justify-center space-x-6 mb-6">
                  <button
                    onClick={prevTestimonial}
                    className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all"
                  >
                    <FaChevronLeft className="text-white" />
                  </button>
                  
                  <div className="text-white font-semibold">
                    {currentIndex + 1} of {testimonials.length}
                  </div>
                  
                  <button
                    onClick={nextTestimonial}
                    className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all"
                  >
                    <FaChevronRight className="text-white" />
                  </button>
                </div>

                {/* Progress Bar */}
                <div className="w-full bg-white/20 rounded-full h-2 mb-4">
                  <div
                    className="h-full bg-gradient-to-r from-blue-400 to-purple-400 rounded-full transition-all duration-500"
                    style={{ width: `${((currentIndex + 1) / testimonials.length) * 100}%` }}
                  />
                </div>

                {/* Auto-play Toggle */}
                <div className="text-center">
                  <button
                    onClick={() => setIsAutoPlaying(!isAutoPlaying)}
                    className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${
                      isAutoPlaying 
                        ? 'bg-blue-400/20 text-blue-400 border border-blue-400/40' 
                        : 'bg-white/10 text-white border border-white/20'
                    }`}
                  >
                    {isAutoPlaying ? 'Pause Auto-play' : 'Resume Auto-play'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Professional Grid Navigation */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-white text-center mb-8">My Professional Network</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-6xl mx-auto">
            {testimonials.map((testimonial, index) => (
              <button
                key={testimonial.id}
                onClick={() => goToSlide(index)}
                className={`relative p-4 rounded-2xl transition-all duration-300 ${
                  index === currentIndex
                    ? 'bg-gradient-to-r from-blue-400/30 to-purple-400/30 border-2 border-white/40 scale-105'
                    : 'bg-white/10 border border-white/20 hover:bg-white/20 hover:scale-105'
                }`}
              >
                <div className="flex flex-col items-center text-center space-y-2">
                  <div className={`w-16 h-16 rounded-full overflow-hidden border-2 ${
                    index === currentIndex ? 'border-white' : 'border-white/50'
                  }`}>
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="text-white text-xs font-medium">
                    {testimonial.name.split(' ')[0]}
                  </div>
                  <div className="text-gray-400 text-xs">
                    {testimonial.company.split(' ')[0]}...
                  </div>
                </div>
                
                {index === currentIndex && (
                  <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-blue-400 rounded-full" />
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Bottom Stats Section */}
        <div className="mt-20">
          <div className="bg-white/5 backdrop-blur-lg rounded-3xl p-8 border border-white/10">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold text-blue-400 mb-2">
                  {testimonials.length}+
                </div>
                <div className="text-gray-300">
                  Professional Connections
                </div>
              </div>
              
              <div>
                <div className="text-3xl font-bold text-purple-400 mb-2">
                  {testimonials.reduce((sum, t) => sum + t.rating, 0) / testimonials.length}
                </div>
                <div className="text-gray-300">
                  Average Rating
                </div>
              </div>
              
              <div>
                <div className="text-3xl font-bold text-green-400 mb-2">
                  {new Set(testimonials.map(t => t.location.split(',').pop().trim())).size}
                </div>
                <div className="text-gray-300">
                  Locations Represented
                </div>
              </div>
              
              <div>
                <div className="text-3xl font-bold text-orange-400 mb-2">
                  {testimonials.flatMap(t => t.specializations).length}+
                </div>
                <div className="text-gray-300">
                  Technical Skills
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Dots Navigation */}
        <div className="text-center mt-12">
          <div className="flex justify-center space-x-3 mb-4">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-4 h-4 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? 'bg-blue-400 shadow-lg shadow-blue-400/50 scale-125'
                    : 'bg-white/30 hover:bg-white/50'
                }`}
              />
            ))}
          </div>
          <p className="text-gray-400 text-sm">
            Click on any professional to view their testimonial
          </p>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-500/10 to-purple-500/10 backdrop-blur-lg rounded-3xl p-8 border border-white/10">
            <h3 className="text-2xl font-bold text-white mb-4">
              Want to Connect?
            </h3>
            <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
              Join our growing network of professionals and industry experts. Share your experience and connect with like-minded individuals.
            </p>
            <button
              onClick={addNewTestimonial}
              className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-3 rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 transition-all transform hover:scale-105"
            >
              <FaPlus className="inline mr-2" />
              Add Your Testimonial
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnhancedTestimonialsEditor;


// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { 
//   FaQuoteLeft, 
//   FaQuoteRight, 
//   FaChevronLeft, 
//   FaChevronRight,
//   FaStar,
//   FaLinkedin
// } from "react-icons/fa";

// const EnhancedTestimonials = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isAutoPlaying, setIsAutoPlaying] = useState(true);

//   const testimonials = [
//     {
//       id: 1,
//       name: "Dideesh Babu",
//       role: "Full Stack Developer | React.js | Blockchain",
//       content: "Congratulations Maneesh! Your dedication to blockchain technology and innovative approach to problem-solving is truly inspiring. Keep pushing the boundaries!",
//       image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
//       rating: 5,
//       company: "Tech Innovations Ltd"
//     },
//     {
//       id: 2,
//       name: "Adarsh S",
//       role: "Postdoctoral Researcher (Blockchain)",
//       content: "Congratulations Maneesh Madhusudhanan! Your research contributions and technical expertise in blockchain development are remarkable. Excited to see your future projects!",
//       image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
//       rating: 5,
//       company: "Research Institute"
//     },
//     {
//       id: 3,
//       name: "Niraja Shenoy",
//       role: "Research and Development Engineer | Blockchain",
//       content: "Congrats Maneesh! Your passion for blockchain technology and ability to deliver complex solutions is outstanding. Looking forward to more collaborations!",
//       image: "https://images.unsplash.com/photo-1494790108755-2616b612b3fd?w=150&h=150&fit=crop&crop=face",
//       rating: 5,
//       company: "BlockTech Solutions"
//     },
//     {
//       id: 4,
//       name: "Neethu M",
//       role: "Innovation Engineer – Blockchain | Hyperledger",
//       content: "Congratulations! 🎉 Your expertise in Hyperledger Fabric and innovative blockchain solutions continues to amaze me. Keep up the excellent work!",
//       image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
//       rating: 5,
//       company: "Hyperledger Foundation"
//     },
//     {
//       id: 5,
//       name: "Kiran SS",
//       role: "Electrical Engineer / Substation Operations",
//       content: "Congrats Maneesh! Your ability to bridge traditional engineering with cutting-edge blockchain technology is impressive. Great work on your recent projects!",
//       image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
//       rating: 5,
//       company: "Power Grid Corp"
//     },
//     {
//       id: 6,
//       name: "Maneesha Raj",
//       role: "Software Engineer | MERN Stack Developer",
//       content: "👏👏👏 Amazing work Maneesh! Your full-stack development skills combined with blockchain expertise make you a true tech innovator. Congratulations!",
//       image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
//       rating: 5,
//       company: "Dev Solutions Inc"
//     },
//     {
//       id: 7,
//       name: "Arun P S",
//       role: "Project Manager | 8 Years Agile & Traditional",
//       content: "Congratulations! 🎉 Working with Maneesh has been fantastic. His technical skills and project delivery capabilities are top-notch. Well deserved success!",
//       image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=150&h=150&fit=crop&crop=face",
//       rating: 5,
//       company: "Agile Tech Partners"
//     },
//   ];

//   // Auto-rotation effect
//   useEffect(() => {
//     if (!isAutoPlaying) return;
    
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % testimonials.length);
//     }, 5000);
    
//     return () => clearInterval(interval);
//   }, [isAutoPlaying, testimonials.length]);

//   const nextTestimonial = () => {
//     setCurrentIndex((prev) => (prev + 1) % testimonials.length);
//     setIsAutoPlaying(false);
//   };

//   const prevTestimonial = () => {
//     setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//     setIsAutoPlaying(false);
//   };

//   const goToSlide = (index) => {
//     setCurrentIndex(index);
//     setIsAutoPlaying(false);
//   };

//   return (
//     <section 
//       id="testimonials" 
//       className="relative min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 overflow-hidden"
//     >
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0">
//         <motion.div
//           animate={{ 
//             rotate: [0, 360],
//             scale: [1, 1.1, 1]
//           }}
//           transition={{ 
//             duration: 20, 
//             repeat: Infinity, 
//             ease: "linear" 
//           }}
//           className="absolute top-20 left-20 w-64 h-64 bg-gradient-to-r from-blue-400/20 to-purple-400/20 rounded-full blur-xl"
//         />
//         <motion.div
//           animate={{ 
//             rotate: [360, 0],
//             scale: [1, 0.8, 1]
//           }}
//           transition={{ 
//             duration: 25, 
//             repeat: Infinity, 
//             ease: "linear" 
//           }}
//           className="absolute bottom-20 right-20 w-80 h-80 bg-gradient-to-r from-pink-400/20 to-blue-400/20 rounded-full blur-xl"
//         />
//       </div>

//       <div className="relative z-10 container mx-auto px-6 py-20">
//         {/* Section Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           viewport={{ once: true }}
//           className="text-center mb-20"
//         >
//           <motion.div
//             initial={{ scale: 0 }}
//             whileInView={{ scale: 1 }}
//             transition={{ delay: 0.2, duration: 0.6 }}
//             className="inline-block mb-6"
//           >
//             <div className="bg-gradient-to-r from-blue-400 to-purple-400 p-4 rounded-full">
//               <FaQuoteLeft className="text-white text-2xl" />
//             </div>
//           </motion.div>
          
//           <motion.h2
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.4, duration: 0.8 }}
//             className="text-5xl md:text-7xl font-bold text-white mb-6"
//           >
//             What People 
//             <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
//               {" "}Say
//             </span>
//           </motion.h2>
          
//           <motion.p
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             transition={{ delay: 0.6, duration: 0.8 }}
//             className="text-xl text-gray-300 max-w-3xl mx-auto"
//           >
//             Recognition and encouragement from industry professionals and peers
//           </motion.p>
//         </motion.div>

//         {/* Main Testimonial Display */}
//         <div className="relative max-w-6xl mx-auto">
//           <AnimatePresence mode="wait">
//             <motion.div
//               key={currentIndex}
//               initial={{ opacity: 0, x: 100 }}
//               animate={{ opacity: 1, x: 0 }}
//               exit={{ opacity: 0, x: -100 }}
//               transition={{ duration: 0.5 }}
//               className="grid lg:grid-cols-2 gap-12 items-center"
//             >
//               {/* Testimonial Content */}
//               <motion.div
//                 initial={{ opacity: 0, y: 50 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.2, duration: 0.6 }}
//                 className="relative"
//               >
//                 <div className="absolute -top-6 -left-6 text-6xl text-blue-400/30">
//                   <FaQuoteLeft />
//                 </div>
                
//                 <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20">
//                   <div className="flex items-center mb-6">
//                     {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
//                       <motion.div
//                         key={i}
//                         initial={{ opacity: 0, scale: 0 }}
//                         animate={{ opacity: 1, scale: 1 }}
//                         transition={{ delay: 0.3 + i * 0.1 }}
//                       >
//                         <FaStar className="text-yellow-400 text-xl mr-1" />
//                       </motion.div>
//                     ))}
//                   </div>
                  
//                   <motion.p
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ delay: 0.4, duration: 0.8 }}
//                     className="text-lg md:text-xl text-white leading-relaxed mb-8 italic"
//                   >
//                     {testimonials[currentIndex].content}
//                   </motion.p>
                  
//                   <motion.div
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: 0.6, duration: 0.6 }}
//                     className="flex items-center justify-between"
//                   >
//                     <div className="flex items-center space-x-4">
//                       <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-blue-400">
//                         <img
//                           src={testimonials[currentIndex].image}
//                           alt={testimonials[currentIndex].name}
//                           className="w-full h-full object-cover"
//                         />
//                       </div>
//                       <div>
//                         <h4 className="text-white font-semibold text-lg">
//                           {testimonials[currentIndex].name}
//                         </h4>
//                         <p className="text-gray-300 text-sm">
//                           {testimonials[currentIndex].role}
//                         </p>
//                         <p className="text-blue-400 text-sm">
//                           {testimonials[currentIndex].company}
//                         </p>
//                       </div>
//                     </div>
                    
//                     <motion.a
//                       href="#"
//                       whileHover={{ scale: 1.1 }}
//                       whileTap={{ scale: 0.9 }}
//                       className="text-blue-400 hover:text-blue-300 transition-colors"
//                     >
//                       <FaLinkedin size={24} />
//                     </motion.a>
//                   </motion.div>
//                 </div>
                
//                 <div className="absolute -bottom-6 -right-6 text-6xl text-purple-400/30">
//                   <FaQuoteRight />
//                 </div>
//               </motion.div>

//               {/* Navigation and Thumbnails */}
//               <motion.div
//                 initial={{ opacity: 0, scale: 0.8 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 transition={{ delay: 0.4, duration: 0.6 }}
//                 className="space-y-8"
//               >
//                 {/* Navigation Controls */}
//                 <div className="flex items-center justify-center space-x-4">
//                   <motion.button
//                     onClick={prevTestimonial}
//                     whileHover={{ scale: 1.1 }}
//                     whileTap={{ scale: 0.9 }}
//                     className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all"
//                   >
//                     <FaChevronLeft className="text-white" />
//                   </motion.button>
                  
//                   <div className="text-white font-semibold">
//                     {currentIndex + 1} / {testimonials.length}
//                   </div>
                  
//                   <motion.button
//                     onClick={nextTestimonial}
//                     whileHover={{ scale: 1.1 }}
//                     whileTap={{ scale: 0.9 }}
//                     className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all"
//                   >
//                     <FaChevronRight className="text-white" />
//                   </motion.button>
//                 </div>

//                 {/* Thumbnail Grid */}
//                 <div className="grid grid-cols-3 gap-4">
//                   {testimonials.map((testimonial, index) => (
//                     <motion.button
//                       key={testimonial.id}
//                       onClick={() => goToSlide(index)}
//                       whileHover={{ scale: 1.05 }}
//                       whileTap={{ scale: 0.95 }}
//                       className={`relative p-4 rounded-2xl transition-all duration-300 ${
//                         index === currentIndex
//                           ? 'bg-gradient-to-r from-blue-400/30 to-purple-400/30 border-2 border-white/40'
//                           : 'bg-white/10 border border-white/20 hover:bg-white/20'
//                       }`}
//                     >
//                       <div className="flex flex-col items-center text-center space-y-2">
//                         <div className={`w-12 h-12 rounded-full overflow-hidden border-2 ${
//                           index === currentIndex ? 'border-white' : 'border-white/50'
//                         }`}>
//                           <img
//                             src={testimonial.image}
//                             alt={testimonial.name}
//                             className="w-full h-full object-cover"
//                           />
//                         </div>
//                         <div className="text-white text-xs font-medium">
//                           {testimonial.name.split(' ')[0]}
//                         </div>
//                       </div>
                      
//                       {index === currentIndex && (
//                         <motion.div
//                           layoutId="activeIndicator"
//                           className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-blue-400 rounded-full"
//                         />
//                       )}
//                     </motion.button>
//                   ))}
//                 </div>

//                 {/* Progress Bar */}
//                 <div className="w-full bg-white/20 rounded-full h-2">
//                   <motion.div
//                     className="h-full bg-gradient-to-r from-blue-400 to-purple-400 rounded-full"
//                     initial={{ width: "0%" }}
//                     animate={{ 
//                       width: `${((currentIndex + 1) / testimonials.length) * 100}%` 
//                     }}
//                     transition={{ duration: 0.5 }}
//                   />
//                 </div>

//                 {/* Auto-play Toggle */}
//                 <motion.button
//                   onClick={() => setIsAutoPlaying(!isAutoPlaying)}
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   className={`mx-auto block px-6 py-2 rounded-full text-sm font-medium transition-all ${
//                     isAutoPlaying 
//                       ? 'bg-blue-400/20 text-blue-400 border border-blue-400/40' 
//                       : 'bg-white/10 text-white border border-white/20'
//                   }`}
//                 >
//                   {isAutoPlaying ? 'Pause Auto-play' : 'Resume Auto-play'}
//                 </motion.button>
//               </motion.div>
//             </motion.div>
//           </AnimatePresence>
//         </div>

//         {/* Bottom Decorative Elements */}
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ delay: 1, duration: 0.8 }}
//           className="text-center mt-20"
//         >
//           <div className="flex justify-center space-x-2 mb-4">
//             {testimonials.map((_, index) => (
//               <motion.button
//                 key={index}
//                 onClick={() => goToSlide(index)}
//                 whileHover={{ scale: 1.2 }}
//                 className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                   index === currentIndex
//                     ? 'bg-blue-400 shadow-lg shadow-blue-400/50'
//                     : 'bg-white/30 hover:bg-white/50'
//                 }`}
//               />
//             ))}
//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default EnhancedTestimonials;



// import React from "react";
// import { motion } from "framer-motion";
// import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";

// const Testimonials = () => {
//   const testimonials = [
//     {
//       id: 1,
//       name: "Dr. Sarah Chen",
//       role: "Blockchain Research Lead",
//       company: "MIT Digital Currency Initiative",
//       content:
//         "Maneesh demonstrates exceptional understanding of both theoretical and practical aspects of blockchain technology. His work on DAO governance showcases innovative thinking in decentralized systems.",
//       image:
//         "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
//     },
//     {
//       id: 2,
//       name: "Rajesh Kumar",
//       role: "CTO",
//       company: "DeFi Protocol Labs",
//       content:
//         "Working with Maneesh on smart contract development was a game-changer. His attention to security and gas optimization helped us deploy a robust protocol that handles millions in TVL.",
//       image:
//         "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
//     },
//     {
//       id: 3,
//       name: "Dr. Elena Rodriguez",
//       role: "Director",
//       company: "Kerala Blockchain Academy",
//       content:
//         "Maneesh's internship with us was outstanding. He quickly grasped complex concepts and delivered production-ready code. His enthusiasm for blockchain education is inspiring.",
//       image:
//         "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
//     },
//     {
//       id: 4,
//       name: "Alex Thompson",
//       role: "Product Manager",
//       company: "Web3 Infrastructure Co.",
//       content:
//         "Maneesh brings a unique perspective combining traditional software engineering with cutting-edge blockchain knowledge. His full-stack approach ensures seamless user experiences.",
//       image:
//         "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
//     },
//     {
//       id: 5,
//       name: "Priya Sharma",
//       role: "Founder",
//       company: "NFT Marketplace Startup",
//       content:
//         "Maneesh helped us build a secure and scalable NFT platform. His expertise in IPFS integration and smart contract optimization was invaluable to our success.",
//       image:
//         "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
//     },
//   ];

//   return (
//     <section id="testimonials" className="py-20 bg-gray-50">
//       <div className="container mx-auto px-4">
//         {/* Section Title */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           viewport={{ once: true }}
//           className="text-center mb-16"
//         >
//           <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//             Testimonials
//           </h2>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             Feedback from colleagues, mentors, and collaborators who have
//             witnessed the impact of my work.
//           </p>
//         </motion.div>

//         {/* Testimonials Grid */}
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {testimonials.map((testimonial, index) => (
//               <motion.div
//                 key={testimonial.id}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: index * 0.1 }}
//                 viewport={{ once: true }}
//                 className="group"
//               >
//                 <motion.div
//                   whileHover={{ y: -5, scale: 1.02 }}
//                   className="bg-white rounded-xl shadow-lg p-6 h-full hover:shadow-xl transition-all duration-300"
//                 >
//                   {/* Quote Icon */}
//                   <div className="flex justify-between items-start mb-4">
//                     <FaQuoteLeft className="text-blue-500 text-xl opacity-50" />
//                     <FaQuoteRight className="text-blue-500 text-xl opacity-50" />
//                   </div>

//                   {/* Content */}
//                   <p className="text-gray-700 leading-relaxed mb-6 italic">
//                     "{testimonial.content}"
//                   </p>

//                   {/* Author Info */}
//                   <div className="flex items-center space-x-4">
//                     <div className="w-12 h-12 rounded-full overflow-hidden">
//                       <img
//                         src={testimonial.image}
//                         alt={testimonial.name}
//                         className="w-full h-full object-cover"
//                       />
//                     </div>
//                     <div>
//                       <h4 className="font-semibold text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
//                         {testimonial.name}
//                       </h4>
//                       <p className="text-sm text-gray-600">
//                         {testimonial.role}
//                       </p>
//                       <p className="text-xs text-gray-500">
//                         {testimonial.company}
//                       </p>
//                     </div>
//                   </div>
//                 </motion.div>
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         {/* Call to Action */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8, delay: 0.4 }}
//           viewport={{ once: true }}
//           className="text-center mt-16"
//         >
//           <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white max-w-4xl mx-auto">
//             <h3 className="text-2xl font-bold mb-4">
//               Join the Growing List of Satisfied Clients
//             </h3>
//             <p className="text-lg opacity-90 mb-6">
//               Let's work together to create innovative blockchain solutions that
//               exceed expectations.
//             </p>
//             <motion.a
//               href="#contact"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="inline-flex items-center space-x-2 bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg"
//             >
//               <span>Start Your Project</span>
//               <FaQuoteRight />
//             </motion.a>
//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;
